import SearchFooter from '../components/SearchFooter';
import searchFooterConnector from './ConnectedSearchFooterBase';

export default searchFooterConnector(SearchFooter);
